import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import {
  BtnIconStyle,
  ContentStyle,
  DataGridListStyle,
  BtnGroupStyle,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import AddNewClinic from "./AddNewClinic";
import ConfirmPopup from "../../components/ConfirmPopup";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { ClinicDetails, RemoveClinic } from "../../Apis/AuthApiServices";
import NoRecords from "../../components/NoRecords";
import { v4 as uuid } from "uuid";
import YSSnackBar from "../../uikit/YSSnackBar";
import ErrorOverlay from "../../components/ErrorOverlay";
import useFetch from "../../CustomHooks/useFetch";
import UpdateClinic from "./UpdateClinic";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

export default function ClinicalInformation() {
  const [addNewClinicPopup, setAddNewClinicPopup] = useState(false);
  const [updateClinicPopUp, setupdateClinicPopUp] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectionData, setSelectionData] = useState("");

  const handleShowAddNewClinicPopupClick = () => {
    setAddNewClinicPopup(true);
  };
  const handleHideAddNewClinicPopupClick = () => {
    setAddNewClinicPopup(false);
  };
  const handleShowUpdateClinicPopupClick = () => {
    setupdateClinicPopUp(true);
  };
  const handleHideUpdateClinicPopupClick = () => {
    setupdateClinicPopUp(false);
  };

  const [deleteDataPopup, setDeleteDataPopup] = useState(false);
  const handleShowDeletePopupClick = () => {
    setDeleteDataPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteDataPopup(false);
  };
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();

      params.append("doctorId", doctorId);
      params.append("SelectedclinicAddressIds", selectionData);
      const result = await RemoveClinic(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        fetchApi();
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const [superId, setSuperId] = useState("");
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const doctorId: any = localStorage.getItem("doctorId");
  const Params = {
    doctorId:
      UserServiceState?.profileGroup > 6
        ? localStorage.getItem("SupervisorDoctorId")
        : localStorage.getItem("doctorId"),
    pageNumber: page,
  };
  const { data, loading, error, fetchApi }: any = useFetch(
    Params,
    ClinicDetails,
    [
      page,
      superId,
      UserServiceState?.profileGroup != null && UserServiceState?.profileGroup,
    ]
  );

  useEffect(() => {
    const handleStorage = () => {
      const pId: any = localStorage.getItem("SupervisorDoctorId");
      setSuperId(pId);
    };

    window.addEventListener("storage", handleStorage);

    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  const NotPrimary = () => {
    return data[0]?.items
      ?.map((item: any) => item?.primary && item?.personAddressId)
      .includes(selectionData[0]);
  };

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  const columnsClinicalInformation: GridColDef[] = [
    {
      field: "addressLineOne",
      headerName: "ClinicAddress",
      width: 450,
      cellClassName: "w55",
      headerClassName: "w55",
      renderCell: ({ row }) => {
        return (
          <Typography component="div" color="primary" variant="body2">
            {row?.location +
              " " +
              row?.addressLineOne +
              " " +
              row?.addressLineTwo +
              " " +
              row?.city +
              " " +
              row?.state +
              " " +
              row?.zip}
          </Typography>
        );
      },
    },

    {
      field: "phoneno",
      headerName: "Phone",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "faxno",
      headerName: "Fax",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "primary",
      headerName: "PrimaryFlag",
      width: 110,
      cellClassName: "w15",
      headerClassName: "w15",
    },
  ];
  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={0}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} md={4}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Clinical Information{" "}
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      The prescribers' clinical addresses, including those he is
                      connected to. both a primary and secondary clinic.
                    </Typography>
                  </>
                }
              />
            </Typography>
          </Grid>{" "}
          <Grid item xs={12} md={8}>
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                columnGap: 5,
              }}
            >
              <Typography component="span" variant="body2">
                Selected ({selectionData.length})
              </Typography>

              <BtnIconStyle>
                <Tooltip title="Delete">
                  <IconButton
                    type="button"
                    className="trash"
                    onClick={handleShowDeletePopupClick}
                  >
                    <img src={TrashIcon} alt="Delete" loading="lazy" />
                  </IconButton>
                </Tooltip>
              </BtnIconStyle>
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data[0]?.items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                paginationMode="server"
                columns={columnsClinicalInformation}
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                checkboxSelection
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                getRowId={(row) => row.personAddressId ?? uuid()}
                pagination
                loading={loading}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={() => {
                  if (
                    selectionData.length === 1
                    //  && !NotPrimary()
                  ) {
                    handleShowUpdateClinicPopupClick();
                  } else {
                    SetStateData((prevState: any) => {
                      return {
                        ...prevState,
                        message: "Please Select Only One Clinic To Update.",
                        //Please Select one Clinic to update & Primary Clinic can't be update",
                        variant: "error",
                        open: true,
                      };
                    });
                  }
                }}
                className=""
                children={"Update"}
                size={"large"}
                type="button"
                color="primary"
                variant="outlined"
              />{" "}
              <YSButton
                onClick={handleShowAddNewClinicPopupClick}
                className=""
                children={"Add New"}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
      <DialogPopup
        windowsize={"md"}
        show={addNewClinicPopup}
        handleShowPopupClick={handleShowAddNewClinicPopupClick}
        handleHidePopupClick={handleHideAddNewClinicPopupClick}
        title="Add New Clinic"
      >
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
          bgcolor={""}
          padding={"10px"}
          borderRadius={"8px"}
          // marginY={3}
        >
          <Grid item xs={12}>
            <AddNewClinic
              fetchApi={fetchApi}
              handleHidePopupClick={handleHideAddNewClinicPopupClick}
            />
          </Grid>
        </Grid>
      </DialogPopup>
      <DialogPopup
        windowsize={"md"}
        show={updateClinicPopUp}
        handleShowPopupClick={handleShowUpdateClinicPopupClick}
        handleHidePopupClick={handleHideUpdateClinicPopupClick}
        title="Update Clinic"
      >
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
          bgcolor={""}
          padding={"10px"}
          borderRadius={"8px"}
          // marginY={3}
        >
          <Grid item xs={12}>
            <UpdateClinic
              fetchApi={fetchApi}
              selectionData={selectionData}
              isPrimaryClinic={NotPrimary()}
              handleHidePopupClick={handleHideUpdateClinicPopupClick}
            />
          </Grid>
        </Grid>
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={deleteDataPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
